import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=6248510e&"
import script from "./Budgets.vue?vue&type=script&lang=ts&"
export * from "./Budgets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports